import React from 'react';
import { View, StyleSheet, Pressable, Platform } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { AnchorRect, useAnchoredPosition } from '@/hooks/common/useAnchoredPosition';

export const AnchoredDropdown = ({
  isOpen,
  anchor,
  width = 240,
  maxHeight = 320,
  children,
  onRequestClose,
}: {
  isOpen: boolean;
  anchor: AnchorRect | null;
  width?: number;
  maxHeight?: number;
  children: React.ReactNode;
  onRequestClose?: () => void;
}) => {
  const { top, left, maxHeight: mh } = useAnchoredPosition(anchor, { width, maxHeight });
  if (!isOpen || !anchor) return null;

  const content = (
    <View style={styles.portalRoot} pointerEvents="box-none">
      <Pressable style={styles.backdrop} onPress={onRequestClose} />
      <View style={[styles.panel, { top, left, width, maxHeight: mh }] }>
        {children}
      </View>
    </View>
  );

  if (Platform.OS === 'web') {
    const { createPortal } = require('react-dom');
    const body = (globalThis as any)?.document?.body;
    if (body) return createPortal(content, body);
    return null;
  }

  return content;
};

const styles = StyleSheet.create({
  portalRoot: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  panel: {
    position: 'absolute',
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    borderRadius: 8,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOpacity: 0.24,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 8 },
    elevation: 20,
    zIndex: 999999,
  },
});


